interface PhoneMockupProps {
  src: string;
  alt: string;
  className?: string;
  /** Fixed pixel width. Omit to let the parent control sizing via CSS. */
  width?: number;
}

export function PhoneMockup({ src, alt, className = "", width }: PhoneMockupProps) {
  return (
    <div
      className={`relative shadow-2xl ${className}`}
      style={{ width: width ?? "100%", aspectRatio: "280/596" }}
    >
      {/* Screenshot sits under the SVG bezel — percentages match the 5px bezel in the 280×596 SVG */}
      <div
        className="absolute overflow-hidden bg-black"
        style={{ inset: "0.84% 1.79%", borderRadius: "16.67% / 7.68%" }}
      >
        <img
          src={src}
          alt={alt}
          className="w-full h-full object-cover object-top"
          loading="lazy"
        />

        {/* Dynamic Island notch overlay */}
        <div className="absolute top-[1%] left-1/2 -translate-x-1/2 z-10 w-[30%] h-[3.2%] bg-black rounded-full" />
      </div>

      {/* Vector phone shell with transparent screen cutout */}
      <img
        src="/images/iphone-frame.svg"
        alt=""
        aria-hidden="true"
        className="relative z-10 w-full h-full pointer-events-none select-none"
      />
    </div>
  );
}
